module.exports = __webpack_public_path__ + "img/objactive-c.68761fd9.png";